import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24",
  fill: "none"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M9.2636 17.7364C8.91213 17.3849 8.91213 16.8151 9.26361 16.4636L13.7272 12L9.2636 7.53639C8.91213 7.18492 8.91213 6.61507 9.26361 6.2636C9.61508 5.91213 10.1849 5.91213 10.5364 6.26361L15.6364 11.3636C15.9879 11.7151 15.9879 12.285 15.6364 12.6364L10.5364 17.7364C10.1849 18.0879 9.61507 18.0879 9.2636 17.7364Z",
  fill: "currentColor"
}, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_3]))
}
export default { render: render }